import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { TreeBuilder } from '../../General/Tree/tree-builder';
import { ColorTreeRepBuilder } from '../../General/Tree/colorTree/color-tree-rep-builder';
import { ColorTreeNoRepBuilder } from '../../General/Tree/colorTree/color-tree-no-rep-builder';
import { WordTreeNoRepBuilder } from '../../General/Tree/wordTree/word-tree-no-rep-builder';
import { WordTreeRepBuilder } from '../../General/Tree/wordTree/word-tree-rep-builder';
import { AllWordsRep } from './all-words-rep';
import { AllWordsNoRep } from './all-words-no-rep';
import { TreeNode } from '../../General/Tree/lib/tree-node';
import { TreeService } from '../../General/Tree/tree.service';
import { TreeRepBuilder } from '../../General/Tree/tree-rep-builder';


@Component({
  selector: 'app-t-all-words',
  templateUrl: './t-all-words.component.html',
  styleUrls: ['./t-all-words.component.css']
})
export class TAllWordsComponent extends GeneralTeacherComponent implements OnInit {
  private graph: TreeBuilder = null;
  private canvas: HTMLCanvasElement = null;
  private generateTreeButton: HTMLButtonElement = null;
  private hideContentButton: HTMLButtonElement = null;

  private readonly canvasID: string = 'graph-canvas';
  private readonly generateTreeID: string = 'generateTree';
  private readonly hideContentID: string = 'hideContent';

  private readonly treeService: TreeService;

  private readonly maxWordLength: number = 5;

  private readFromConfig = false;

  alphabet: string = "";
  wordLength: number = 0;
  hasCharRepetition: string = "false";



  constructor(protected topicsService: TopicService,
    protected activatedRoute: ActivatedRoute,
    treeService: TreeService) {
    super(topicsService, activatedRoute);
    this.type = 'allWords';
    // this.title = this.get('coloredFlags');
    this.title = 'allWords';
    this.treeService = treeService;
  }

  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);
    this.hideContentButton = <HTMLButtonElement>document.getElementById(this.hideContentID);

    //If we load from configfile we dont need to create a new empty graph
    if (!this.readFromConfig) {
      this.generateTreeButton.addEventListener('click', this.generateTree, false);
      this.hideContentButton.addEventListener('click', this.hideContent, false)

    }
  }
  hideContent = () => {
    if (this.graph == null) {
      return;
    }


    if (this.graph instanceof AllWordsNoRep) {
      let sub = <AllWordsNoRep>this.graph;
      sub.selectHideMode(!sub.getHideMode());
      if (sub.getHideMode()) {
        this.canvas.style.cursor = 'alias';
      }
      else {
        this.canvas.style.cursor = 'default'
      }
    }
    else if (this.graph instanceof AllWordsRep) {
      let sub = <AllWordsRep>this.graph;
      sub.selectHideMode(!sub.getHideMode());

      if (sub.getHideMode()) {
        this.canvas.style.cursor = 'alias';
      }
      else {
        this.canvas.style.cursor = 'default'
      }
    }


  }
  generateTree = () => {

    if (this.wordLength == 0 || this.alphabet.length == 0)
      return;

    let treeAlphabet: string[] = this.alphabet.split(",");

    if (this.hasCharRepetition == 'true') {
      this.graph = new AllWordsRep(this.wordLength, treeAlphabet, this.canvas);
    }
    else {
      this.wordLength = Math.min(treeAlphabet.length, this.wordLength);
      this.graph = new AllWordsNoRep(this.wordLength, treeAlphabet, this.canvas);
    }


    this.graph.buildTree();
    this.graph.update();

    /*   console.log("-------------------------------------");
       this.graph.getNodes().forEach(n => {
         let tn : TreeNode = <TreeNode>n;
         console.log(tn.getContent());
       });
       console.log("------------------")*/

  }


  getWordLength(): number[] {
    let i = 0;
    let res = [];
    for (i = 1; i <= this.maxWordLength; i++) {
      res.push(i);
    }
    return res;
  }

  generateDefinition(): any {

    const definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/allWords.png';
    definition.key = 'listingWithTreeDiagrams%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }

    /**
     * Export tree to json file
     */
    let hiddenNodes: TreeNode[] = [];
    this.graph.getNodes().forEach(node => {
      if (node instanceof TreeNode) {
        let tNode: TreeNode = <TreeNode>node;
        if (tNode.isHidden()) {
          hiddenNodes.push(tNode);
        }
      }
    });
    let hasRep:boolean = (this.graph instanceof TreeRepBuilder);

    this.treeService.exportTreeOld("words", this.graph.getSet(),
      this.graph.getDepth(), hasRep, definition);


    this.treeService.exportHiddenNodes(hiddenNodes, definition);

    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    /*Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized*/
    let alphabet: any[] = this.treeService.importTreeOld(this.configuration)[0];
    let depth: number = this.treeService.importTreeOld(this.configuration)[1];
    let hasRep: boolean = this.treeService.importHasRepetition(this.configuration);

    if (hasRep) {
      this.graph = new AllWordsRep(depth, alphabet, this.canvas);
    } else {
      this.graph = new AllWordsNoRep(depth, alphabet, this.canvas);
    }

    for (let i = 0; i < alphabet.length; i++){
      if(i == 0){
        this.alphabet = alphabet[i];
      }
      else{
        this.alphabet = this.alphabet +","+alphabet[i];
      }
    }

    this.wordLength = depth;

    this.graph.buildTree();
    this.initHiddenNodes();
    
    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);
    this.hideContentButton = <HTMLButtonElement>document.getElementById(this.hideContentID);

    //If we load from configfile we dont need to create a new empty graph
    if (!this.readFromConfig) {
      this.generateTreeButton.addEventListener('click', this.generateTree, false);
      this.hideContentButton.addEventListener('click', this.hideContent, false)

    }

    this.graph.update();
    this.readFromConfig = true;
  }

  private initHiddenNodes(){
    let hiddenContent: any[][] = this.treeService.importHiddenNodes(this.configuration);
    this.graph.getNodes().forEach(node => {
      if (node instanceof TreeNode) {
        let n: TreeNode = <TreeNode>node;
        let realContent = n.getContent();
        hiddenContent.forEach(content => {
          let hasSameContent: boolean = this.sameContent(realContent,content);
          if (hasSameContent) {
            n.setHidden(true);
          }
        })
      }
    })
  }

  private sameContent(realContent: any[], content: any[]): boolean {
    let hasSameContent: boolean = true;
    hasSameContent = content.length == realContent.length;

    let i: number = 0;
    for(i = 0; i < content.length; i++){
      hasSameContent = hasSameContent && (content[i] == realContent[i]);
    }
    return hasSameContent;
  }


}


